<script setup>
// Our Work detail page's nav column: just the page TOC now. Used to also
// hold a "Key outputs" panel with a 3-layout variant switcher comparing how
// TOC+outputs could sit together (see
// docs/superpowers/specs/2026-08-03-our-work-template-design.md /
// docs/features/completed/jk-17-our-work-template.md) — removed per jk-34
// (Key outputs dropped from the page entirely, leaving nothing for the
// variants to differentiate).
import PageToc from '@/components/PageToc.vue'

defineProps({
  tocItems: { type: Array, required: true },
})
</script>

<template>
  <aside class="our-work-sidebar">
    <div class="panel toc">
      <PageToc :items="tocItems" />
    </div>
  </aside>
</template>
